(function (analytics) {
    "use strict";

    analytics.plugins = analytics.plugins || [];

    analytics.plugins.push(function () {

      //DFA VIS ID
      var dfaID = "3435399";
      var dfaType = "dfaig010";
      var dfaCat = "dfaig011";
      var variables = "u1";
      var marketingCloudVisitorID = nadex.marketing.analytics.sitecatalyst.marketingCloudVisitorID;
      var url = 'https://fls.doubleclick.net/activityi;src=' + dfaID + ';type=' + dfaType + ';cat=' + dfaCat + ';' + variables + '=' + marketingCloudVisitorID + ';ord=1;num=' + (Math.random() * 1000000) + '?';
      
      //window.setTimeout(function() {

        //console.log("nadex analytics: dfavisid init");

        if (marketingCloudVisitorID) {

          var dfaIframe = document.createElement("iframe");
          dfaIframe.setAttribute("src", url);
          dfaIframe.setAttribute("width", "1");
          dfaIframe.setAttribute("height", "1");
          dfaIframe.setAttribute("frameborder", "0");
          dfaIframe.setAttribute("style", "display:none");
          document.getElementsByTagName("body")[0].appendChild(dfaIframe);

          console.log("nadex analytics: dfavisid set");
        } else {
          console.log("nadex analytics: dfavisid blank: ", marketingCloudVisitorID);
        }
        
      //}, 2000);
      
      //console.log("image created: ", url);
      //console.log("your visitor id is: ", marketingCloudVisitorID)


    });
})(window.nadex.marketing.analytics);